import { ExploreTestID } from "@/constants/TestID";
import { Text } from "@/ui/core";
import { Box, VStack } from "@/ui/layout";
import { HeroImageBackground } from "@/ui/layout/HeroImageBackground";
import { ColorToken, LayoutToken } from "@/ui/theme/tokens";
import { isWeb } from "@/utils/platform.util";

const ExploreContentHeader = () => {
  const { gap, height, imageSource, justifyContent } = isWeb()
    ? {
        height: "100%",
        imageSource: require("@/assets/images/explore-web.png"),
        justifyContent: "center" as const,
      }
    : {
        gap: 52,
        imageSource: require("@/assets/images/explore.png"),
      };
  return (
    <HeroImageBackground imageSource={imageSource}>
      <Box
        justifyContent={justifyContent}
        paddingHorizontal={LayoutToken.ContentPaddingHorizontal}
        testID={ExploreTestID.Header}
        width="100%"
      >
        <VStack
          alignItems="flex-start"
          gap={gap}
          height={height}
          paddingVertical={24}
        >
          {!isWeb() && (
            <Text testID={ExploreTestID.Title} variant="h5">
              Explore
            </Text>
          )}
          <VStack gap={8}>
            <Text
              color={ColorToken.Secondary70}
              testID={ExploreTestID.Subtitle}
              variant="h3"
            >
              Go beyond treatment
            </Text>
            {isWeb() ? (
              <>
                <Text
                  color={ColorToken.Secondary70}
                  testID={ExploreTestID.Description}
                >
                  Find groups, videos, articles and more to
                </Text>
                <Text
                  color={ColorToken.Secondary70}
                  testID={ExploreTestID.Description}
                >
                  help you throughout your treatment journey.
                </Text>
              </>
            ) : (
              <Text
                color={ColorToken.Secondary70}
                testID={ExploreTestID.Description}
              >
                Find groups, videos, articles and more to help you throughout
                your treatment journey.
              </Text>
            )}
          </VStack>
        </VStack>
      </Box>
    </HeroImageBackground>
  );
};

export { ExploreContentHeader };
